import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { KpiDefinition, KpiDefinitionCreate, KpiDefinitionFilter } from '../data/kpiDefinition';

export function createKpiDefinitionService(client: AxiosInstance) {
  return createCrudService<KpiDefinition, KpiDefinitionCreate, KpiDefinitionFilter>(
    client,
    '/reporting/KpiDefinition',
    'id',
  );
}

export type KpiDefinitionService = CrudService<KpiDefinition, KpiDefinitionCreate, KpiDefinitionFilter>;
